import { i18n as appI18n } from '../../../localization/i18n';

/**
 * i18n wrapper for CallKit
 * Delegates to the main app i18n service which has all translation keys (including calls.STATUS.*)
 */
export const i18n = {
    t: (key, options) => appI18n.t(key, options),
    get language() {
        return appI18n.language || 'en';
    },
    subscribe: callback => appI18n.subscribe(callback),
    setLanguage: lang => appI18n.setLanguage(lang),
};
